/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Acknowledgmentrequired4Inputs */

const en_coinvestments_submitticketsize_modal_acknowledgmentrequired4 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Acknowledgmentrequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acknowledgment is required`)
};

/**
* | output |
* | --- |
* | "Acknowledgment is required" |
*
* @param {Coinvestments_Submitticketsize_Modal_Acknowledgmentrequired4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_acknowledgmentrequired4 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Acknowledgmentrequired4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Acknowledgmentrequired4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_acknowledgmentrequired4(inputs)
});
export { coinvestments_submitticketsize_modal_acknowledgmentrequired4 as "coInvestments_submitTicketSize_modal_acknowledgmentRequired" }